var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex h-full w-full items-center justify-center p-6"},[_c('user-data-input-component',{on:{"registered":function($event){return _vm.$emit('registered')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }